import { Config } from '#app/config'

export let rudder: Awaited<ReturnType<typeof getSdk>> | undefined

export async function initRudderSdk() {
  if (!Config.RUDDERSTACK_WRITE_KEY || !Config.RUDDERSTACK_DATAPLANE_URL) return

  const rudderAnalytics = await getSdk()

  rudderAnalytics.load(
    Config.RUDDERSTACK_WRITE_KEY,
    Config.RUDDERSTACK_DATAPLANE_URL,
  )
  rudderAnalytics.page()

  rudder = rudderAnalytics
}

async function getSdk() {
  const { RudderAnalytics } = await import(
    '@rudderstack/analytics-js/bundled' /* webpackChunkName: "rudder-sdk" */
  )

  return new RudderAnalytics()
}
